import {ChatContentQuotes} from "../routines/schemas";

// ---------------------------------------------------------------------------
// Enums
// ---------------------------------------------------------------------------

export enum MessageStatus {
    PENDING = "PENDING",
    PROCESSING = "PROCESSING",
    COMPLETE = "COMPLETE",
    ERROR = "ERROR",
}

export enum ActionStatus {
    RUNNING = "RUNNING",
    COMPLETE = "COMPLETE",
    ERROR = "ERROR",
}

// ---------------------------------------------------------------------------
// Nested types
// ---------------------------------------------------------------------------

export type AgentAction = {
    name: string;
    status: ActionStatus;
    result_summary?: string | null;
};

export type ChatMessageState = {
    status: MessageStatus;
    actions: AgentAction[];
    summary?: string | null;
};

export type ChatMessageContent = {
    text?: string | null;
    content_chunks?: ChatContentQuotes[] | null;
    metadata?: Record<string, unknown> | null;
};

// ---------------------------------------------------------------------------
// Read model (returned by API)
// ---------------------------------------------------------------------------

export type ChatMessageRead = {
    id: string;
    created_at: string;
    chat_id: string;
    role: string;
    sender_id: string;
    content?: ChatMessageContent | null;
    state?: ChatMessageState | null;
};
